import { BaseStore } from '../stores';
import { action, computed, observable } from 'mobx';
import { Stores } from '../models/Stores';
import { models } from '@kurtosys/ksys-app-template';
import {
    IPaginationChangeDetail,
    IUpdatePaginationDetail,
} from '@kurtosys/ksys-app-template/dist/models/eventBus';

export class PaginationStore extends BaseStore {
    @observable pageStart = 0;
    @observable pageLimit = 0;
    lastKnownIdentifier: string;

    constructor(stores: Stores) {
        super(stores);
    }

    @computed
    get config() {
        return this.stores.data.config;
    }

    @computed
    get appConfig() {
        return this.config && this.config.appConfig;
    }

    @computed
    get pagingConfig() {
        return this.config.paging;
    }

    @computed
    get identifier() {
        const pagingConfig = this.pagingConfig;

        if (pagingConfig && pagingConfig.identifier) {
            this.lastKnownIdentifier = pagingConfig.identifier;
            return pagingConfig.identifier;
        }

        return;
    }

    @action
    updatePaging = (pageStart: number, pageLimit: number) => {
        this.pageStart = pageStart;
        this.pageLimit = pageLimit;
    };

    public updatePagination = async (totalRecords: number) => {
        if (this.pagingConfig.mode === 'paginationApp') {
            const { eventBusStore } = this.stores;
            const eventBody: IUpdatePaginationDetail = {
                identifier: this.identifier,
                pagingData: {
                    totalRecords,
                    pageSize: this.pageLimit,
                    recordIndex: this.pageStart,
                },
            };
            eventBusStore.trigger(models.eventBus.EventType.updatePagination, {
                detail: eventBody,
            });
        } else {
            this.hidePagination();
        }
    };

    public hidePagination = async () => {
        if (this.lastKnownIdentifier) {
            const { eventBusStore } = this.stores;
            const eventBody: IUpdatePaginationDetail = {
                identifier: this.lastKnownIdentifier,
            };
            eventBusStore.trigger(models.eventBus.EventType.updatePagination, {
                detail: eventBody,
            });
            this.lastKnownIdentifier = undefined;
        }
    };

    public paginationChange = async (detail: IPaginationChangeDetail) => {
        if (this.pagingConfig.mode === 'paginationApp') {
            if (detail && detail.newPagingData) {
                this.updatePaging(
                    detail.newPagingData.recordIndex,
                    detail.newPagingData.pageSize
                );
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/stores/PaginationStore.ts